import type { SVGProps } from "react";

const UsersIcon = ({
  width = 30,
  height = 30,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M18 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM19 23c2.761 0 5-1.343 5-3s-2.239-3-5-3-5 1.343-5 3 2.239 3 5 3Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="M12.001 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM12.001 24.001c3.866 0 7-1.79 7-4s-3.134-4-7-4-7 1.79-7 4 3.134 4 7 4Z"
    />
  </svg>
);
export default UsersIcon;
